import { z } from 'zod'
import { enumerated } from '~/prix'
import { dateOrIsoString } from '~/prix/types/date'
import sql from '~/prix/utils/sql'

export const trainingType = enumerated({
  training: 'Treinamento',
  talk: 'Palestra',
  course: 'Curso',
})

export const trainingTypeOptions = (trainingType.getMeta()?.keysAndLabels ?? {}) as Record<
  string,
  string
>

export const trainingObject = z.object({
  id: z.string().uuid(),
  type: trainingType,
  title: z.string(),
  observation: z.string().nullish(),
  sourceFilter: z.string().nullish(),
  clientId: z.number().int().nullish(),
  insertUserId: z.string().nullish(),
  editUserId: z.string().nullish(),
  createdAt: dateOrIsoString().nullish(),
  updatedAt: dateOrIsoString().nullish(),
  deletedAt: dateOrIsoString().nullish(),
})

export type TrainingType = z.infer<typeof trainingObject>

export const propertyMap = {
  id: sql`training.id`,
  type: sql`training.type`,
  title: sql`training.title`,
  observation: sql`training.observation`,
  sourceFilter: sql`training.source_filter`,
  clientId: sql`training.client_id`,
  insertUserId: sql`training.insert_user_id`,
  editUserId: sql`training.edit_user_id`,
  createdAt: sql`training.created_at`,
  updatedAt: sql`training.updated_at`,
  deletedAt: sql`training.deleted_at`,
}

export default trainingObject
